import { createReducer, createSelector } from 'redux-starter-kit';
import { putPurchaseHistory } from './purchaseHistoryActions';


/**
 * A selector for the outcomes loaded in the domain state.
 * This is a keyed object: { outcomeCode: outcome, ... }
 * @param {object} state The redux state of the application.
 * @returns A keyed object of the inspection outcomes.
 * @example const outcome = selectOutcomesMap(state)[outcomeId];
 */
export const selectPurchaseHistoryMap = state => state.via.domain.purchases;


/**
 * A selector for the inspection outcomes loaded in the domain state.
 * This is a list: [ outcome, outcome, ...]
 * @param {object} state The redux state of the application.
 * @returns An array of inspection outcomes.
 * @example const outcomes = selectOutcomes(state);
 */
export const selectPurchaseHistory = createSelector(['via.domain.purchases'], map => (map ? Object.values(map) : null));

/**
 * A selector for an inspection outcome that is loaded in the domain state.
 * @param {object} state The redux state of the application.
 * @param {number} outcomeCode The id of the outcome.
 * @example const outcome = selectOutcome(state, outcomeCode);
 */
export const selectPurchase = (state, code) => {
  const purchaseMap = selectPurchaseHistoryMap(state);
  if (!purchaseMap) return null;

  return purchaseMap[code];
};

export default createReducer({}, {
  // Replaces all the packages in the state.
  [putPurchaseHistory]: (state, action) => {
    const purchaseHistory = action.payload;

    return purchaseHistory.reduce((newState, purchase) => {
      newState[purchase.code] = purchase; // eslint-disable-line no-param-reassign
      return newState;
    }, { });
  },
});
